import { Icon } from "@iconify/react";
import "./nointernet.css";

const NoInternetScreen = () => {
  return (
    <div className="no-internet-container">
      <div className="no-internet-card">
        <div className="icon-wrapper">
          <Icon icon="mdi:wifi-off" />
        </div>

        <h2 className="no-internet-title">Sin conexión a Internet</h2>

        <p className="no-internet-text">
          Parece que perdiste la conexión. Verifica tu red para poder continuar.
        </p>

        <button
          className="no-internet-btn"
          onClick={() => window.location.reload()}
        >
          Reintentar
        </button>
      </div>
    </div>
  );
};

export default NoInternetScreen;
